import React from 'react'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import { ArrowLeftIcon } from '../../Icons/ArrowIcons'

interface BackButtonProps {
  title: string
  handleBack: () => void
}

const BackButton = ({ title, handleBack }: BackButtonProps): JSX.Element => {
  return (
    <button className='rf-relative rf-w-full rf-flex rf-flex-row rf-items-center rf-pb-6 rf-pl-4 rf-pt-4 large:rf-pt-8' onClick={handleBack} aria-label={title} data-map='fermer'>
      <ArrowLeftIcon className='rf-w-8' />
      <div className='rf-ml-1'>{capitalizeFirstLetter(title)}</div>
    </button>
  )
}

export default BackButton
